<template>
    <div class="flex space-x-4">

        <div :class="[
            calculateScoreClass(data.lighthouse_performance_score),
            'border-2',
            'p-2',
            'rounded-lg'
        ]">
            {{ data.lighthouse_performance_score }}
            <div>
                <small>Performance</small>
            </div>
        </div>

        <div :class="[
            calculateScoreClass(data.lighthouse_accessibility_score),
            'border-2',
            'p-2',
            'rounded-lg'
        ]">
            {{ data.lighthouse_accessibility_score }}
            <div>
                <small>Accessibility</small>
            </div>
        </div>

        <div :class="[
            calculateScoreClass(data.lighthouse_best_practices_score),
            'border-2',
            'p-2',
            'rounded-lg'
        ]">
            {{ data.lighthouse_best_practices_score }}
            <div>
                <small>Best Practices</small>
            </div>
        </div>

        <div :class="[
            calculateScoreClass(data.lighthouse_seo_score),
            'border-2',
            'p-2',
            'rounded-lg'
        ]">
            {{ data.lighthouse_seo_score }}
            <div class="border-red">
                <small>SEO</small>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "PageSeo",
    props: {
        data: {
            type: Object,

        }
    },
    methods: {
        calculateScoreClass: function(score){
            if(score >= 90){
                return "border-green-700 dark:border-green-300 text-green-700 dark:text-green-300 bg-green-200 dark:bg-green-800";
            }else if (score >= 50 && score <= 89){
                return "border-yellow-700 dark:border-yellow-300 text-yellow-700 dark:text-yellow-300 bg-yellow-200 dark:bg-yellow-800";
            }else{
                return "border-red-700 dark:border-red-300 text-red-700 dark:text-red-300 bg-red-200 dark:bg-red-800";
            }
        },
    }
}
</script>
